export default __webpack_public_path__ + "static/media/Jacob Southfield .25f4c40e.jpg";